// extracted by mini-css-extract-plugin
module.exports = {"list":"download-desktop-dropdown_list_3Xa","inlineTrigger":"download-desktop-dropdown_inlineTrigger_3oh","fullWidth":"download-desktop-dropdown_fullWidth_3kr"};